import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { FormButtons, renderers, titleCase } from '../../components'

let OTPReceiverForm = (props) => {
  const { handleSubmit, pristine, reset, submitting, contactNumbers,submitText } = props
  const contactNumbersOptions = contactNumbers
  return (
    <form onSubmit={handleSubmit}>
      {contactNumbersOptions &&
        contactNumbersOptions
          .filter((x, i, a) => a.indexOf(x) === i)
          .map((description, index) => (
            <Field
              name="otp_receiver"
              value={description.name}
              key={index + description.name}
              label={titleCase(description.name)}
              component={renderers.renderRadioFieldWithClickableLabel}
              type="radio"
            />
          ))}
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} submitText={submitText}/>
    </form>
  )
}
OTPReceiverForm = reduxForm({
  form: 'OTPReceiverForm',
})(OTPReceiverForm)

export default OTPReceiverForm
